import {
  BrowserRouter as Router,
  Switch,
} from "react-router-dom";
import { useSelector } from "react-redux";

// import { PrivateRoute } from "./PrivateRoute";
// import { Role } from "../_helpers/role";
import Home from "../pages/Home";
import Login from "../pages/Login";
import Inmuebles from "../pages/Secciones/Inmuebles";
import Abogados from "../pages/Secciones/Abogados";
import Abogado from "../components/Abogado/Abogado";
import CondicionesLegales from "../pages/Secciones/CondicionesLegales";
import Contribuyentes from "../pages/Secciones/Contribuyentes";
import Inmueble from "../pages/Secciones/Contribuyentes/Components/Inmueble/Inmueble";
import Convenios from "../pages/Secciones/Convenios";
// import GestionLegal from "../pages/Secciones/GestionLegal";
import PlanesDePago from "../pages/Secciones/PlanesDePago";
import Estadisticas from "../pages/Secciones/Estadisticas";
import NotFound from "../pages/NotFound";
import { PrivateRoute } from "./PrivateRoute";
import { PublicRoute } from "./PublicRoute";
import MisContribuyentes from "../pages/Secciones/MisContribuyentes/MisContribuyentes";
import Registros from "../pages/Secciones/Registros";
import Honorarios from "../pages/Secciones/Honorarios";
import Historial from "../pages/Secciones/Historico";
import Comercios from "../pages/Secciones/Comercios";
import GestionLegalPanel from "../pages/Secciones/GestionLegal/GestionLegalPanel";
import EvaluacionAbogados from "../pages/Secciones/EvaluacionAbogados";
import MisDatos from "../pages/Secciones/MisDatos";
import MesaEntradasJudicial from "../pages/Secciones/MesaEntradasJudicial";
import MesaEntradasExtrajudicial from "../pages/Secciones/MesaEntradasExtrajudicial";
import Titulos from "../pages/Secciones/Titulos";
import Comunicaciones from "../pages/Secciones/Comunicaciones";
import CreacionTitulos from "../pages/Secciones/CreacionTitulos";
import AbogadoExterno from "../pages/Secciones/AbogadoExterno";
import RegistrosLogin from "../pages/Secciones/RegistrosLogin";

export const Routes = () => {
  const { loggingIn } = useSelector((state) => state.authentication);

  if (loggingIn) return <h2>Cargando...</h2>;

  return (
    <Router>
      <Switch>
        <PublicRoute exact path="/" component={Login} name="login" />
        <PrivateRoute exact path="/home" component={Home} name="home" />

        {/* acceso publico */}
        <PrivateRoute exact path="/contribuyentes" component={Contribuyentes} />
        <PrivateRoute exact path="/inmuebles" component={Inmuebles} />
        <PrivateRoute exact path="/comercios" component={Comercios} />
        <PrivateRoute exact path="/abogados/usuario" component={Abogado} />
        <PrivateRoute exact path="/inmueble/:id" component={Inmueble} />
        <PrivateRoute exact path="/convenios" component={Convenios} />
        <PrivateRoute exact path="/gestion" component={GestionLegalPanel} />
        <PrivateRoute exact path="/planes-de-pago" component={PlanesDePago} />
        <PrivateRoute exact path="/estadisticas" component={Estadisticas} />
        <PrivateRoute exact path="/registros" component={Registros} />
        <PrivateRoute exact path="/comunicaciones" component={Comunicaciones} />
        <PrivateRoute exact path="/mis-datos" component={MisDatos} />
        <PrivateRoute exact path="/mesa-extrajudicial" component={MesaEntradasExtrajudicial} />
        <PrivateRoute exact path="/mesa-judicial" component={MesaEntradasJudicial} />
        <PrivateRoute exact path="/abogado-externo" component={AbogadoExterno} />
        <PrivateRoute exact path="/scoring-abogados" component={EvaluacionAbogados} />
        <PrivateRoute exact path="/titulos" component={Titulos} />
        <PrivateRoute exact path="/registroslogin" component={RegistrosLogin} />

        {/* acceso restringido */}
        <PrivateRoute exact path="/novedades" component={MisContribuyentes} isAdmin />
        <PrivateRoute exact path="/abogados" component={Abogados} isAdmin />
        <PrivateRoute exact path="/condiciones" component={CondicionesLegales} isAdmin />
        <PrivateRoute exact path="/configuracion" component={Honorarios} isAdmin />
        <PrivateRoute exact path="/historial" component={Historial} isAdmin />
        <PrivateRoute exact path="/creaciontitulos" component={CreacionTitulos} isAdmin />

        <PrivateRoute path="*" component={NotFound} />
      </Switch>
    </Router>
  );
};
